var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWishList = function SvgWishList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#WishList_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4980F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 15-.651-.582a64.555 64.555 0 0 1-2.148-1.972c-.565-.547-1.01-1.034-1.335-1.461-.326-.427-.551-.817-.677-1.17A3.215 3.215 0 0 1 5 8.728c0-.767.265-1.413.794-1.94C6.324 6.264 6.974 6 7.747 6c.426 0 .838.09 1.237.272.4.18.738.435 1.016.762a2.864 2.864 0 0 1 1.016-.762c.399-.181.811-.272 1.237-.272.772 0 1.423.263 1.953.789S15 7.96 15 8.729c0 .37-.06.728-.182 1.073s-.345.728-.67 1.15c-.326.423-.773.912-1.342 1.468a70.114 70.114 0 0 1-2.181 2.024L10 15Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "WishList_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgWishList;